/* script */
const __vue_script__ = {}
/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 612 612"},attrs:{"aria-hidden":"true","version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"612px","height":"612px","viewBox":"0 0 612 612","xml:space":"preserve"}},[_c('g',[_c('g',[_c('path',{attrs:{"d":"M0,306.39c0,55.219,41.338,101.035,95.639,109.882l19.139,1.529h106.599v-55.441H116.085l-12.685-1.001\n\t\t\t\tc-36.665-5.842-47.764-28.041-49.35-57.055c-1.53-27.735,24.703-52.465,70.436-68.238c0,0-33.771-44.982,0-73.245\n\t\t\t\ts82.537,24.591,82.537,24.591S268.14,71.242,358.993,79.755c137.116,12.88,126.323,164.6,126.323,164.6\n\t\t\t\ts71.381,12.212,71.381,59.948c0,53.272-60.782,58.056-60.782,58.056H391.374v55.441H497.25l19.111-1.529\n\t\t\t\tC570.662,407.425,612,361.608,612,306.39c0-48.515-31.936-89.825-76.527-105.097c-1.614-96.084-82.343-173.474-181.653-173.474\n\t\t\t\tc-71.632,0-133.583,40.253-163.181,98.754c-13.993-15.022-34.244-24.48-56.777-24.48c-42.256,0-76.5,33.271-76.5,74.274\n\t\t\t\tc0,10.71,2.336,20.892,6.509,30.071C26.038,224.66,0,262.576,0,306.39z"}}),_vm._v(" "),_c('polygon',{attrs:{"points":"278.182,194.727 278.182,512.383 166.909,445.091 166.909,500.728 306,584.182 445.091,500.728 445.091,445.091 \n\t\t\t\t333.818,512.383 333.818,194.727 \t\t"}})])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DownloadButton.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__